<div
  class="text-multiple-choice-train-answer text-center"
  [class.text-multiple-choice-train-answer-hidden]="!isBackVisible()"
  [class.text-multiple-choice-train-answer-missed]="missedAnswer"
  [attr.aria-hidden]="!isBackVisible() ? 'true' : null"
>
  @if (isBackVisible() && card().explanation) {
    <p class="text-multiple-choice-train-explanation">
      {{ card().explanation }}
    </p>
  }
</div>

@if (isMultipleSelection && !isBackVisible()) {
  <p class="text-multiple-choice-train-instruction text-center">
    {{ t()["train.selectAllCorrectOptions"] }}
  </p>
}

<div class="text-multiple-choice-train-options">
  @for (option of shuffledOptions(); track option.id || option.text) {
    <button
      type="button"
      class="text-multiple-choice-train-option text-start"
      [attr.data-testid]="'training-option-' + option.id"
      [class.text-multiple-choice-train-option-selected]="
        !isBackVisible() && isOptionSelected(option)
      "
      [class.text-multiple-choice-train-option-correct]="
        isBackVisible() && option.isCorrect
      "
      [class.text-multiple-choice-train-option-incorrect]="
        isBackVisible() && isOptionSelected(option) && isCorrect() === false
      "
      [attr.aria-label]="optionAriaLabel(option)"
      [disabled]="isBackVisible()"
      (click)="selectOption(option)"
    >
      {{ option.text }}
    </button>
  }
</div>
